import react from "./react.svg";
import flutter from "./flutter.svg";
import nodeJS from "./nodejs.svg";
import electron from "./electron.svg";
import mongoDB from "./mongodb.svg";
import angular from "./angular.svg";
import git from "./git-icon.svg";
import mySQL from "./mysql.svg";
import boostrap from "./bootstrap.svg";
import firebase from "./firebase.svg";
import nestjs from "./nestjs.svg";

const techIcons = [
  react,
  flutter,
  nodeJS,
  electron,
  mongoDB,
  angular,
  git,
  mySQL,
  boostrap,
  firebase,
  nestjs
];

export default techIcons;
